<v2-row id="sheet-header" justifyContent="space-between" alignItems="center">
  <v2-button
    *ngIf="!(isTopLevelSheet$ | async); else elseBlock"
    id="back-button"
    class="action-button"
    (click)="goBack()"
  >
    <v2-icon icon="disclosure-left" color="primary" id="back-icon"></v2-icon>
    <v2-text color="black">Back</v2-text>
  </v2-button>
  <ng-template #elseBlock><div></div></ng-template>

  <v2-button (click)="bottomSheetRef.close()" class="action-button">
    <v2-text color="medium-grey">Cancel</v2-text>
  </v2-button>
</v2-row>

<div
  id="modifier-groups-cont"
  *ngIf="parentModifier$ | async as parentModifier"
>
  <v2-modifier-group
    *ngFor="let modifierGroup of parentModifier.modifierGroups; trackBy: modifierGroupService.stdGroupTrackByFn"
    [parentModifier]="parentModifier"
    [modifierGroup]="modifierGroup"
    [showValidationState]="!!(showValidationState$ | async)"
  >
  </v2-modifier-group>
</div>

<v2-row id="footer-cont">
  <v2-button
    color="primary"
    [outline]="true"
    *ngIf="shouldShowSkipButton$ | async"
    (click)="proceed()"
  >
    SKIP
  </v2-button>
  <v2-button
    color="primary"
    *ngIf="shouldShowNextButton$ | async"
    (click)="proceed()"
  >
    NEXT
  </v2-button>
</v2-row>
